/* V78 · WEB-013 — GAME NIGHT STORYTELLING SLIDER
 *
 * Lėtas kinematografiškas perėjimas per 8 vakaro kadrus.
 *
 * ELGSENA
 *   - automatinis keitimas pagal sekcijos nustatymą (numatyta 6 s);
 *   - hover ir focus PRISTABDO, pelei pasitraukus tęsia;
 *   - bet koks rankinis veiksmas (rodyklė, taškas, swipe, klaviatūra)
 *     ATSTATO laikmatį iš naujo, kad kadras neperšoktų iškart po
 *     paspaudimo;
 *   - begalinis ciklas abiem kryptimis;
 *   - swipe mobiliajame;
 *   - kairė/dešinė rodyklės klaviatūroje, kai fokusas sekcijoje.
 *
 * PRIEINAMUMAS
 *   - `prefers-reduced-motion` išjungia automatiką VISIŠKAI ir
 *     panaikina perėjimo animaciją. Vartotojas valdo pats;
 *   - neaktyvūs kadrai gauna `aria-hidden`, neaktyvūs tekstai `hidden`,
 *     todėl ekrano skaitytuvas skaito tik matomą turinį;
 *   - `aria-live="polite"` ant teksto bloko praneša pasikeitimą;
 *   - taškai turi `aria-selected`.
 *
 * IDEMPOTENT INIT
 *   Tas pats `dataset.gnReady` principas, kaip kituose temos moduliuose —
 *   Theme Editor perkraunant sekciją listeneriai ir laikmačiai
 *   nesidubliuoja.
 */
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function Story(root) {
    if (root.dataset.gnReady === '1') return;
    root.dataset.gnReady = '1';

    var slides = [].slice.call(root.querySelectorAll('[data-gn-slide]'));
    var texts = [].slice.call(root.querySelectorAll('[data-gn-text]'));
    var dots = [].slice.call(root.querySelectorAll('[data-gn-dot]'));
    var nowEl = root.querySelector('[data-gn-now]');
    var prev = root.querySelector('[data-gn-prev]');
    var next = root.querySelector('[data-gn-next]');
    var stage = root.querySelector('[data-gn-stage]');
    if (slides.length < 2) return;

    var total = slides.length;
    var idx = 0;
    var timer = null;
    var paused = false;

    var secs = parseFloat(root.dataset.gnAutoplay);
    if (!isFinite(secs)) secs = 6;
    /* Judesio mažinimo režime automatika neįjungiama iš viso. */
    var delay = REDUCED ? 0 : secs * 1000;

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function show(n) {
      /* Begalinis ciklas abiem kryptimis. */
      idx = (n + total) % total;

      slides.forEach(function (s, i) {
        var on = i === idx;
        s.classList.toggle('is-on', on);
        if (on) s.removeAttribute('aria-hidden');
        else s.setAttribute('aria-hidden', 'true');
      });

      texts.forEach(function (t, i) {
        var on = i === idx;
        t.classList.toggle('is-on', on);
        t.hidden = !on;
      });

      dots.forEach(function (d, i) {
        var on = i === idx;
        d.classList.toggle('is-on', on);
        d.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      if (nowEl) nowEl.textContent = pad(idx + 1);
    }

    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    function start() {
      stop();
      if (!delay || paused) return;
      timer = setInterval(function () { show(idx + 1); }, delay);
    }

    /* Rankinis veiksmas visada atstato laikmatį. */
    function go(n) { show(n); start(); }

    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { go(i); });
    });

    /* Hover ir focus pristabdo. */
    root.addEventListener('mouseenter', function () { paused = true; stop(); });
    root.addEventListener('mouseleave', function () { paused = false; start(); });
    root.addEventListener('focusin', function () { paused = true; stop(); });
    root.addEventListener('focusout', function (e) {
      if (!root.contains(e.relatedTarget)) { paused = false; start(); }
    });

    /* Klaviatūra, kai fokusas sekcijos viduje. */
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
    });

    /* Swipe. `passive` — kad scroll'as neužstrigtų. */
    if (stage) {
      var x0 = null, y0 = null;
      stage.addEventListener('touchstart', function (e) {
        var t = e.changedTouches[0]; x0 = t.clientX; y0 = t.clientY;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var t = e.changedTouches[0];
        var dx = t.clientX - x0, dy = t.clientY - y0;
        /* Horizontalus gestas turi būti aiškiai stipresnis už vertikalų,
           kitaip vartotojas norėjo scroll'inti puslapį. */
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          go(dx < 0 ? idx + 1 : idx - 1);
        }
        x0 = null; y0 = null;
      }, { passive: true });
    }

    /* Nematomos sekcijos laikmatis neturi suktis. */
    var ac = typeof AbortController === 'function' ? new AbortController() : null;
    var opts = ac ? { signal: ac.signal } : false;
    root._gnAbort = ac;
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    }, opts);

    root._gnStop = stop;
    show(0);
    start();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-gnstory]').forEach(Story);
  }

  document.addEventListener('shopify:section:unload', function (e) {
    var r = e.target && e.target.querySelector ? e.target.querySelector('[data-gnstory]') : null;
    if (r && r._gnAbort) { try { r._gnAbort.abort(); } catch (err) {} }
    if (r && r._gnStop) { try { r._gnStop(); } catch (err) {} }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
